import { useMutation } from '@apollo/client';
import {
    ModalContent,
    ModalTitle,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { css } from '@emotion/react';
import { captureException } from '@sentry/react';
import { Grid } from '@material-ui/core';
import { Body1 } from '../../blocks';
import { MenuItem, TextField } from '@material-ui/core';
import { UPDATE_CLAIM } from '../../ClaimDetails/graphql';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '@/components/App';

const REJECTION_REASONS = ['Claim form not completed', 'Improper supporting documents', 'Claim denied', 'Other'];

const RejectClaimModal = ({ claim, open, onClose, onSave, callbacks }) => {
    const [reason, setReason] = useState('');
    const { user } = useContext(UserContext);

    useEffect(() => {
        setReason('');
    }, [claim]);

    const [updateClaim, { loading: saveInFlight }] = useMutation(UPDATE_CLAIM, {
        onError: (error) => {
            console.error(error);
            captureException(error);
            callbacks.setNotification({
                severity: 'error',
                message: `Failed to update claim. ${error.message}`,
            });
        },
    });

    const rejectClaim = () => {
        updateClaim({
            variables: {
                claim_id: claim.claim_id,
                update: {
                    claim_status: 'REJECTED',
                    rejection_reason: reason,
                    completed_by: user.user_id,
                    rejected_at: new Date().toISOString(),
                },
            },
        }).then(() => {
            onSave();
        });
    };

    return (
        <ResponsiveSidebarDialog open={open} onClose={onClose}>
            <ModalTitle title={'Reject Claim'} onClose={onClose} />
            <ModalContent
                css={css`
                    width: 600px;
                `}
            >
                <Grid container direction="column" css={css``}>
                    <Grid item>
                        <Body1>Rejecting the claim will close the claim with no reimbursement to the shipper.</Body1>
                    </Grid>
                    <Grid item>
                        <Body1>No adjustment made to carrier's pay.</Body1>
                    </Grid>
                    <Grid
                        item
                        css={css`
                            margin-top: 1rem;
                        `}
                    >
                        <TextField
                            variant="outlined"
                            label="Reason for rejection"
                            value={reason || ''}
                            onChange={(e) => setReason(e.target.value)}
                            fullWidth
                            select
                        >
                            {REJECTION_REASONS.map((reason) => (
                                <MenuItem key={reason} value={reason}>
                                    {reason}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid item>
                    <SecondaryButton disabled={saveInFlight} onClick={onClose}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item>
                    <PrimaryButton disabled={saveInFlight || !reason} onClick={rejectClaim}>
                        Reject
                    </PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default RejectClaimModal;
